import { Action } from "redux"

type tToastNotificationType = "info" | "error" | "warning" | "success"

export const OPEN_TOAST_NOTIFICATION = "OPEN_TOAST_NOTIFICATION"
export const CLOSE_TOAST_NOTIFICATION = "CLOSE_TOAST_NOTIFICATION"

export interface iOpenToastNotificationAction extends Action {
    type: typeof OPEN_TOAST_NOTIFICATION
    message: string
    toastType: tToastNotificationType
    expires_at?: number
}

export interface iCloseToastNotificationAction extends Action {
    type: typeof CLOSE_TOAST_NOTIFICATION
}

export const openToastNotification = (message: string, type: tToastNotificationType, expires_in_ms?: number): iOpenToastNotificationAction => {
    return {
        type: OPEN_TOAST_NOTIFICATION,
        message,
        toastType: type,
        expires_at: expires_in_ms ? Date.now() + expires_in_ms : undefined,
    }
}

export const closeToastNotification = (): iCloseToastNotificationAction => {
    return {
        type: CLOSE_TOAST_NOTIFICATION,
    }
}

export type tToastNotificationAction = iOpenToastNotificationAction | iCloseToastNotificationAction
